
function submit_form_data(form_name){
  
  document.getElementById(`loader_${form_name}`).style.display = "block";
  const forms_details = {
    "share_feedback":{
      formName:"Feedback Form",
      formId:"share_feedback",
      customerEmail:"",
      customerName:"",
      fields:[
        {
        name:"Name",
        id:"cust_name",
        value:""
        },
        {
          name:"Email",
          id:"cust_email",
          value:""
        },
        {
          name:"Phone",
          id:"cust_phone",
          value:""
        },
        {
          name:"City",
          id:"cust_city",
          value:""
        },
        {
          name:"State",
          id:"cust_state",
          value:""
        },
        {
          name:"Address",
          id:"cust_address",
          value:""
        },
        {
          name:"Query",
          id:"cust_query",
          value:""
        },
      ]
    },
    "return_gifts":{
      formName:"Return Gifts Form",
      formId:"return_gifts",
      customerEmail:"",
      fields:[
        {
        name:"Name",
        id:"cust_name",
        value:""
        },
        {
          name:"Phone",
         id:"cust_phone",
          value:""
        },
        {
          name:"Email",
          id:"cust_email",

          value:""
        },
        {
          name:"Requirement",
          id:"cust_req",
          value:""
        },
      ]
    },
    "return_gifts_surprise":{
      formName:"Return Gifts Surprise Form",
      formId:"return_gifts_surprise",
      customerEmail:"",
      customerName:"",
      fields:[
        {
        name:"Name",
        id:"cust_name",
        value:""
        },
        {
          name:"Phone",
         id:"cust_phone",
          value:""
        },
        {
          name:"Email",
          id:"cust_email",

          value:""
        },
        {
          name:"Message",
          id:"cust_req",
          value:""
        },
      ]
    },
    "franchise":{
      formName:"Franchise Form",
      formId:"franchise",
      customerEmail:"",
      customerName:"",
      fields:[
        {
        name:"Name",
        id:"cust_name",
        value:""
        },
        {
          name:"Phone",
         id:"cust_phone",
          value:""
        },
        {
          name:"Email",
          id:"cust_email",
          value:""
        },
        {
          name:"Business Location",
          id:"cust_bus_location",
          value:""
        },
        {
          name:"Capital to invest",
          id:"cust_invest",
          value:""
        }
      ]
    },
    "contact_us":{
      formName:"Contact US Form",
      formId:"contact_us",
      customerEmail:"",
      customerName:"",
      fields:[
        {
        name:"Name",
        id:"cust_name",
        value:""
        },
        {
          name:"Phone",
          id:"cust_phone",
          value:""
        },
        {
          name:"Email",
          id:"cust_email",
          value:""
        },
        {
          name:"Comment",
          id:"cust_comment",
          value:""
        },
      ]
    },
    "influencer":{
      formName:"Influencer Form",
      formId:"influencer",
      customerEmail:"",
      customerName:"",
      fields:[
        {
        name:"Name",
        id:"cust_name",
        value:""
        },
        {
          name:"Phone",
          id:"cust_phone",
          value:""
        },
        {
          name:"Email",
          id:"cust_email",
          value:""
        },
        {
          name:"Location",
          id:"inf_location",
          value:""
        },
        {
          name:"Social Media Link",
          id:"inf_social_media_link",
          value:""
        },
        {
          name:"Followers",
          id:"inf_followers",
          value:""
        },
        {
          name:"How do you come to know about us?",
          id:"inf_ref",
          value:""
        },
      ]
    }
    

  }
    console.log(form_name);
  
    let form_data= forms_details[form_name];
    form_data.customerEmail = document.getElementById("cust_email").value;
    form_data.customerName = document.getElementById("cust_name").value;
    const phone = document.getElementById("cust_phone").value;

    let validation = validationFunc(form_data.customerEmail,phone);

    if(validation != 0){
      document.getElementById(`loader_${form_name}`).style.display = "none";
      return
    }
    const empty_fields = [];
    form_data.fields.forEach((field,index)=>{
        let value = document.getElementById(field.id).value;
        if(value == ""){
          empty_fields.push({id:field.id,name:field.name});
        }
      form_data.fields[index].value = value;
    })
    
    console.log(form_data)
    if(empty_fields.length > 0){
      formSubmitError(empty_fields,form_name);
      console.log("isdni")
      return
    }

    // 📨 Prepare data for Cloudflare Worker (SendGrid endpoint)
const payload = {
  name: form_data.customerName,
  email: form_data.customerEmail,
  phone: phone,
  brief: form_data.fields.map(f => `${f.name}: ${f.value}`).join("\n"),
};

// 🧭 Send the data to your Worker endpoint
fetch("https://tight-pond-b68f.himanshu-masant-6f5.workers.dev/", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify(payload),
})
  .then(async (response) => {
    const res = await response.json();
    document.getElementById(`loader_${form_name}`).style.display = "none";

    if (res.success) {
      console.log("✅ Email sent successfully:", res);
      formsubmitted(form_name);
    } else {
      console.error("❌ Error from API:", res.message);
      alert(`Error: ${res.message || "Failed to send email"}`);
    }
  })
  .catch((err) => {
    document.getElementById(`loader_${form_name}`).style.display = "none";
    console.error("⚠️ Network or server error:", err);
    alert("Something went wrong while sending your details. Please try again.");
  });

  //   const options = {
  //     method: 'POST',
  //     url: 'https://shopfiy.scoobies.co.in/data/formsData',
  //     headers: {
  //       Accept: 'application.json',
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(form_data),
  // };

  // fetch('https://shopfiy.scoobies.co.in/data/formsData', options)
  // .then(response => response.json())
  // .then(response => {
  //   document.getElementById(`loader_${form_name}`).style.display = "none";
  //   console.log(response);
  //   if(response.success == true){
  //       formsubmitted(form_name);
  //     }
  // })
  // .catch((err) => {
  //   document.getElementById(`loader_${form_name}`).style.display = "none";
  //   console.error(err)
  // });


    
  
    
  
  }
  
  function formsubmitted(id){
    var form = document.getElementById(id);
    var elements = form.elements;
    for (var i = 0, len = elements.length; i < len; ++i) {
      
      if(elements[i].type != "button"){
        elements[i].readOnly = true;
      elements[i].style.color = "Grey";
      elements[i].style.visibility = "hidden";
          
      }
      else{
      elements[i].style.visibility = "visible";
        elements[i].style.color = "black"
          elements[i].innerHTML = "SHARED"
          elements[i].classList.remove("error_input");
      }
    }
    document.getElementById(`${id}_submission_text`).style.display = "block";
    setTimeout( ()=>{
      window.location.href = "/"
    }, 10000)
  }
  function formsubmittedLittle(id,code){
    var form = document.getElementById(id);
    var elements = form.elements;
    for (var i = 0, len = elements.length; i < len; ++i) {
      
      if(elements[i].type != "button"){
        elements[i].readOnly = true;
      elements[i].style.color = "Grey";
      elements[i].style.visibility = "hidden";
          
      }
      else{
      elements[i].style.visibility = "visible";
        elements[i].style.color = "black"
          elements[i].innerHTML = "SHARED"
          elements[i].classList.remove("error_input");
      }
    }
    document.getElementById(`${id}_submission_text`).innerHTML = `Thanks for providing your details Your unique code is ${code}`

    document.getElementById(`${id}_submission_text`).style.display = "block";
    setTimeout( ()=>{
      window.location.href = "https://www.littletags.com/st-search?q=scoobies"
    }, 10000)
  }

  function formSubmitError(fields,form_name){

    fields.forEach((field,index)=>{
      document.getElementById(field.id).className += ' error_input'
    })
    document.getElementById(`loader_${form_name}`).style.display = "none";
  }
  // function validationFunc (email,phone){
  //   var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  //   var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

  //   let errorC = 0;
  //   if(email.match(mailformat)){
      
  //   }
  //   else{
  //     document.getElementById("cust_email").classList.add("error_input");
  //     errorC = errorC+1;
  //   }
  //   if(phone.match(phoneno) && phone.length >= 10){
  
  //   }
  //   else{
  //     document.getElementById("cust_phone").classList.add("error_input");
  //     errorC = errorC+1;
  //   }
  //   window.alert("invalid input")
  //   return errorC
  // }

  function validationFunc(email, phone) {
  const mailformat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneno = /^[0-9]{10}$/; // for 10-digit numbers (e.g., Indian mobiles)

  let errorC = 0;

  // Email check
  if (!email.match(mailformat)) {
    document.getElementById("cust_email").classList.add("error_input");
    errorC++;
  } else {
    document.getElementById("cust_email").classList.remove("error_input");
  }

  // Phone check
  if (!phone.match(phoneno)) {
    document.getElementById("cust_phone").classList.add("error_input");
    errorC++;
  } else {
    document.getElementById("cust_phone").classList.remove("error_input");
  }

  // 🔴 Show alert only if there’s an error
  if (errorC > 0) {
    window.alert("Invalid input — please check your email and phone number.");
  }

  return errorC;
}

  function validationFuncLittle (email,phone){
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    let errorC = 0;
    if(email.match(mailformat)){
      
    }
    else{
      document.getElementById("cust_email").classList.add("error_input");
      errorC = errorC+1;
    }
    if(phone.match(phoneno) && phone.length >= 10){
  
    }
    else{
      document.getElementById("cust_phone").classList.add("error_input");
      errorC = errorC+1;
    }
    // window.alert("invalid input")
    return errorC
  }

  function submit_form_data_little_tags(form_name){
  
    document.getElementById(`loader_${form_name}`).style.display = "block";
    const forms_details = {
      
      "little_tags":{
        formName:"Little Tag Event",
        formId:"little_tags",
        customerEmail:"",
        customerName:"",
        fields:[
          {
          name:"Name",
          id:"cust_name",
          value:""
          },
          {
            name:"Phone",
            id:"cust_phone",
            value:""
          },
          {
            name:"Email",
            id:"cust_email",
            value:""
          },
          {
            name:"No.of Kids",
            id:"n_kids",
            value:""
          },
          {
            name:"DOB",
            id:"dob",
            value:""
          }
        ]
      }
      
  
    }
      console.log(form_name);
    
      let form_data= forms_details[form_name];
      form_data.customerEmail = document.getElementById("cust_email").value;
      form_data.customerName = document.getElementById("cust_name").value;
      const phone = document.getElementById("cust_phone").value;
      let validation = validationFuncLittle(form_data.customerEmail,phone);
      if(validation != 0){
        document.getElementById(`loader_${form_name}`).style.display = "none";
        return
      }
      const empty_fields = [];
      form_data.fields.forEach((field,index)=>{
          let value = document.getElementById(field.id).value;
          if(value == ""){
            empty_fields.push({id:field.id,name:field.name});
          }
        form_data.fields[index].value = value;
      })
      console.log(form_data)
      if(empty_fields.length > 0){
        formSubmitError(empty_fields,form_name);
        console.log("isdni")
        return
      }
  
  
      const options = {
        method: 'POST',
        url: 'https://shopfiy.scoobies.co.in/data/littleTag',
        headers: {
          Accept: 'application.json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(form_data),
    };
      console.log(options.body)
    fetch('https://shopfiy.scoobies.co.in/data/littleTag', options)
    .then(response => response.json())
    .then(response => {
      document.getElementById(`loader_${form_name}`).style.display = "none";
      console.log(response);
      if(response.success == true){
        debugger;
        formsubmittedLittle(form_name,response.unique_code);
        }
    })
    .catch((err) => {
      document.getElementById(`loader_${form_name}`).style.display = "none";
      console.error(err)
    });
  
  
      
    
      
    
    }